import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Informações do grupo", -1)
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, " Status ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, " Metas que fazem parte do grupo: ", -1)

import { ref, watch, withDefaults, computed, onMounted, PropType } from 'vue';
import { MoleculeModal, MoleculeTable } from '@/components/molecules';
import { AtomButton, AtomInput, AddIcon, AtomToogleButton } from '@/components/atoms';
import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
import { GoalsGroup } from '@/core/model/GoalsGroup';
import { Preloader } from '@/store';
import { create } from '@/core/service/GoalsGroupService';
import Swal from 'sweetalert2';
import { IHeadersTable, IToggleButon } from '@/types';
import { getGoalsByGroup as getGoalsByGroup } from '@/core/service/GoalsService';
import { Goal } from '@/core/model/Goal';
import { formatCurrency } from '@/utils/formatNumber';


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModalGoalsGroup',
  props: {
  showModal: { type: Boolean, required: true, default: false },
  group: {
    type: Object as PropType<GoalsGroup>, required: false
  },
},
  setup(__props) {

const props = __props;

let locale: string = messages[getLanguage()]['message'];
const goals_group = ref<GoalsGroup>({});

const goalName = ref<string>();
const performantQnt = ref<number>();
const margin = ref<string>();
const startDate = ref<Date>();
const endDate = ref<Date>();
const active = ref<boolean>();
const onlyShowData = ref<boolean>(false);
const goals = ref<Goal[]>();
const show = ref<boolean>(props.showModal);

async function loadGoals(id) {
  await getGoalsByGroup(id).then((resp) => {
    for (const data of resp.data) {
      data.start_date = formatDate(data.start_date);
      data.end_date = formatDate(data.end_date);
      data.value = formatCurrency(data.value);
    }
    goals.value = resp.data;
  });
}

onMounted(async () => {
  if (props.group) {
    onlyShowData.value = true;
    goalName.value = props.group.name;
    performantQnt.value = props.group.performants_quantity;
    startDate.value = props.group.start_date;
    endDate.value = props.group.end_date;
    active.value = props.group.active;
    margin.value = formatCurrency(props.group.annual_margin);
    await loadGoals(props.group.id);
  }
})

watch(() => props.showModal, () => {
  show.value = props.showModal;
})

const checkFields = computed(() => {
  const validPerformantQnt = performantQnt.value! >= 0;
  const checkedFields = !!goalName.value && validPerformantQnt && !!startDate.value && !!endDate.value;
  return checkedFields;
})

function formatDate(dateString: string) {
  let [year, month, day] = dateString.split("-").map(Number);
  return `${day < 10 ? `0${day}` : `${day}`}/${month < 10 ? `0${month}` : `${month}`}/${year}`;
}

function registerGroup() {
  goals_group.value = {
    active: true,
    name: goalName.value,
    annual_margin: 0,
    start_date: startDate.value,
    end_date: endDate.value,
    performants_quantity: performantQnt.value
  };

  Preloader.actions.ActionSetPreloader(true);
  create(goals_group.value)
    .then(async () => {
      Swal.fire({
        title: locale['common']['success'],
        text: locale['goals_group']['goal_group_created_successfully'],
        icon: 'success',
      }).then((result) => {
        show.value = false;
      });
      goals_group.value = {};
    })
    .finally(() => {
      Preloader.actions.ActionSetPreloader(false);
      window.location.reload();
    });
}

const actives = ref<IToggleButon[]>([
  { text: 'Ativo', value: '1' },
  { text: 'Inativo', value: '0' },
])

const headers = ref<IHeadersTable[]>([
  { label: "Nome", field: 'name' },
  { label: "Meta", field: 'value' },
  { label: 'Data de início', field: 'start_date' },
  { label: 'Data de fim', field: 'end_date' },
]);



return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    width: "1192px",
    onHasBtnClose: ($event: any) => (false),
    onHasBtnConfirm: ($event: any) => (false),
    onHandleCancel: _cache[5] || (_cache[5] = ($event: any) => (show.value = false)),
    title: "Realizar cadastro do grupo de metas",
    show: show.value
  }, _createSlots({
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_unref(AtomInput), {
                  maxWidth: '100%',
                  label: "Nome",
                  classes: "mb-5",
                  placeholder: "Nome do grupo",
                  modelValue: goalName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((goalName).value = $event)),
                  disabled: onlyShowData.value,
                  required: ""
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_unref(AtomInput), {
                  maxWidth: '100%',
                  label: _ctx.$t('message.common.performer'),
                  classes: "mb-5",
                  placeholder: "Número de performantes",
                  type: "number",
                  modelValue: performantQnt.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((performantQnt).value = $event)),
                  disabled: onlyShowData.value,
                  required: ""
                }, null, 8, ["label", "modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_unref(AtomInput), {
                  maxWidth: '100%',
                  label: "Data de início",
                  classes: "mb-5",
                  type: "date",
                  modelValue: startDate.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startDate).value = $event)),
                  disabled: onlyShowData.value,
                  required: ""
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_unref(AtomInput), {
                  maxWidth: '100%',
                  label: "Data de fim",
                  classes: "mb-5",
                  type: "date",
                  modelValue: endDate.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDate).value = $event)),
                  disabled: onlyShowData.value,
                  required: ""
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          (onlyShowData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_unref(AtomToogleButton), {
                      buttons: actives.value,
                      select: String(active.value),
                      disabled: ""
                    }, null, 8, ["buttons", "select"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      maxWidth: '100%',
                      label: "Meta do grupo",
                      classes: "mb-5",
                      type: "text",
                      modelValue: margin.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((margin).value = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (onlyShowData.value)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    style: {"overflow":"scroll","height":"20em"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createVNode(_unref(MoleculeTable), {
                        headers: headers.value,
                        items: goals.value!,
                        pagination: false,
                        update: false
                      }, null, 8, ["headers", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 2
  }, [
    (!onlyShowData.value)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_unref(AtomButton), {
              outlined: "",
              prependIcon: "",
              background: "green-50",
              outlineColor: "outline-green-500",
              hoverColor: "var(--color-green-100)",
              disabled: !(checkFields.value),
              onClick: _withModifiers(registerGroup, ["stop"])
            }, {
              prependIcon: _withCtx(() => [
                _createVNode(_unref(AddIcon), { color: "#000" })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Registrar grupo ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["show"]))
}
}

})